import React from 'react'
import PropTypes from 'prop-types'
import HighCharts from 'highcharts'
import HighChartsAddons from 'highcharts/highcharts-more'
import Chart from 'highcharts-react-official'
import exportToImage from '../../modules/utils/exports'
import theme from '../../config/styles/theme'
import { formatAmount } from '../../modules/utils/formatters'
import { Exportable, GlobalStyles } from './BubbleChart.styles'

HighChartsAddons(HighCharts)

/**
 * The BubbleChart's component.
 */
const BubbleChart = props => {
  const { categories, fileName, id, inputBubbleChartRef, structure, values } = props
  const options = {
    accessibility: { enabled: false },
    chart: { plotBorderWidth: 1, type: 'bubble', zoomType: 'xy' },
    legend: { enabled: false },
    plotOptions: {
      bubble: { maxSize: 45, minSize: 10 },
      series: {
        marker: {
          fillColor: theme.palette.charts.cinnabar,
          fillOpacity: 0.8,
          lineWidth: 2,
          lineColor: theme.palette.charts.cinnabar,
          opacity: 1
        },
        states: {
          hover: { enabled: false }
        }
      }
    },
    series: [{ data: structure, maxSize: values.max, minSize: values.min, sizeBy: 'width' }],
    title: { text: '' },
    tooltip: {
      borderWidth: 1,
      shadow: true,
      formatter() {
        return `<strong>$${formatAmount(this.y)}</strong> transados en <strong>${this.x}</strong><br /> a través de ${
          this.point.z
        } <strong> órdenes de compra</strong>`
      }
    },
    xAxis: { categories, gridLineWidth: 1 },
    yAxis: {
      endOnTick: false,
      maxPadding: 0.2,
      plotLines: [{ color: 'black', dashStyle: 'dot', width: 2, zIndex: 3 }],
      startOnTick: false,
      title: { text: '' }
    }
  }
  const exportData = () => exportToImage(id, fileName)

  return (
    <>
      <GlobalStyles />
      <Exportable id={id}>
        <Chart highcharts={HighCharts} options={options} />
      </Exportable>
      <Exportable ref={inputBubbleChartRef} onClick={exportData} />
    </>
  )
}

BubbleChart.defaultProps = {
  id: 'bubbleChart'
}

BubbleChart.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.string),
  fileName: PropTypes.string,
  id: PropTypes.string,
  inputBubbleChartRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(window.HTMLDivElement) })
  ]),
  structure: PropTypes.arrayOf(
    PropTypes.shape({
      x: PropTypes.number,
      y: PropTypes.number,
      z: PropTypes.number,
      name: PropTypes.string
    })
  ),
  values: PropTypes.shape({
    min: PropTypes.number,
    max: PropTypes.number
  })
}

export default BubbleChart
